import { render, staticRenderFns } from "./caseCreated.vue?vue&type=template&id=979a257c&scoped=true"
import script from "./caseCreated.vue?vue&type=script&lang=js"
export * from "./caseCreated.vue?vue&type=script&lang=js"
import style0 from "./caseCreated.vue?vue&type=style&index=0&id=979a257c&prod&lang=scss&scoped=true"
import style1 from "./caseCreated.vue?vue&type=style&index=1&id=979a257c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979a257c",
  null
  
)

export default component.exports